<template>
	<div>
		<el-form ref="form" :model="addRechargeFrom" label-width="120px">
			<el-form-item label="充值金额" required>
				<el-input maxlength="12" v-model.trim="addRechargeFrom.money" type="text"><template #append>
						元
					</template></el-input>
			</el-form-item>
			<el-form-item label="优惠金额" required>
				<el-input maxlength="12" v-model.trim="addRechargeFrom.discount_amount" type="text"><template #append>
						元
					</template></el-input>
			</el-form-item>
			<el-form-item label="充值凭证" required>
				<div class="upload-main" v-if="ossData.ossAccessKeyId">
					<uploadRechargeImg @handleSuccess='RechargImgSuccess($event,index)'
						@handleRemove='RechargImgRemove($event,index)' :ossData='ossData' :ossObj="ossObj"
						class="upload-item" v-for="(item,index) in 3" :key="index"></uploadRechargeImg>
				</div>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="addRechargeSubmit">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import uploadRechargeImg from './uploadRechargeImg.vue'
	import reg from '@/utils/reg.js'

	export default {
		components: {
			uploadRechargeImg
		},
		props: ['id', 'type'],
		data() {
			return {
				ossData: {},
				ossObj: {},
				addRechargeFrom: {
					money: '',
					discount_amount: '0',
					recharge_pic1: '',
					recharge_pic2: '',
					recharge_pic3: '',
				}

			};
		},

		methods: {
			async addRechargeSubmit() {
				//校验格式
				// if(this.addRechargeFrom.money==0){
				// 	return this.$message.error('金额不能为零')
				// }

				if (!reg.money.test(this.addRechargeFrom.money)) {
					return this.$message.error('金额格式不正确')
				}
				if (!reg.money.test(this.addRechargeFrom.discount_amount)) {
					return this.$message.error('优惠金额格式不正确')
				}

				let requireLen = Object.values(this.addRechargeFrom).filter(item => item)
				console.log(requireLen)

				//校验填写数量
				if (requireLen.length < 3) {
					return this.$message.error('至少上传一张凭证')
				}
				const res = await this.$api.postAddRechargeRecord({
					company_id: this.$props.id,
					company_type: this.$props.type,
					...this.addRechargeFrom
				})
				if (res) {
					this.$emit('success', 'isShowAddRecharge')
				}
			},
			//移除
			RechargImgRemove(url, index) {
				this.addRechargeFrom['recharge_pic' + (index + 1)] = ''
			},
			//成功
			RechargImgSuccess(url, index) {
				this.addRechargeFrom['recharge_pic' + (index + 1)] = url
				console.log(this.addRechargeFrom)
			},
			//oss上传
			async ossUpload() {
				const res_oss = await this.$api.getOss({
					dir: 'ph/hr/'
				})
				if (res_oss) {
					this.ossObj = res_oss
					this.ossData = {
						ossAccessKeyId: res_oss.accessid,
						policy: res_oss.policy,
						signature: res_oss.signature
					}
				} else {
					this.$message.error('获取oss签名失败')
				}
			},

		},
		created() {
			this.ossUpload()
		},
		mounted() {

		},
	};
</script>

<style lang="scss" scoped>
	.upload-main {
		display: flex;
		justify-content: flex-start;
	}

	.upload-item {
		margin-right: 25px;
	}
</style>
